import React from "react";
import { Col, Row } from "react-bootstrap";
import LabelController from "../../../atoms/Label/LabelController";
import LabelInsideDatePicker from "../../../atoms/InputController/LabelInside/Label-Inside-Datepicker-Controller/LabelInsideDatePicker";

const LeadDatedSection = ({ ...props }) => {
  const { leadDate } = props.newLeadContent;
  const startDate = props.startDate;
  const inputValue = props.inputValue;
  let errors = props.errors;
  return (
    <div className="box-container">
      <Row>
        <LabelController label={leadDate.label} />
        <Col sm={6}>
          <LabelInsideDatePicker
            value={inputValue[leadDate.name]}
            name={leadDate.name}
            placeholder={leadDate.name}
            type={leadDate.type}
            handleDate={props.handleDate}
            label={leadDate.inputLabel}
            errors={errors}
            selected={startDate}
            register={props.register}
          />
        </Col>
      </Row>
    </div>
  );
};

export default LeadDatedSection;
